import Header from "./components/Header";
import Hero from "./components/Hero";
import TagWall from "./components/TagWall";
import IndexList from "./components/IndexList";
import CoverPicks from "./components/CoverPicks";
import ValueBand from "./components/ValueBand";
import Guide from "./components/Guide";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="bg-[#faf5ec] text-[#2a2016]">
      <Header />
      <main>
        <Hero />
        <TagWall />
        <IndexList />
        <CoverPicks />
        <ValueBand />
        <Guide />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}